import "./Footer.scss";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Facebook, Instagram, LogoTypo } from "../../assets/svg/svgIcons";
import {
  ORGANIZATION,
  ORGANIZATION_ADDRESS_INLINE,
} from "../../config/organization";
import { SOCIAL_LINKS } from "../../config/socials";

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  // Router links do not reset the scroll position on navigation.
  const scrollToTop = () => window.scrollTo(0, 0);

  return (
    <footer className="footer">
      <LogoTypo className="logoFooter" />
      <div className="footerText">
        <address className="footerLegal">
          <strong>{ORGANIZATION.legalName}</strong>
          <span>{t("footer.legalForm")}</span>
          <span>
            {t("footer.companyNumberLabel")} : {ORGANIZATION.companyNumber}
          </span>
          <span>{ORGANIZATION_ADDRESS_INLINE}</span>
        </address>
        <nav className="footerLinks" aria-label="Legal navigation">
          <p>© {currentYear} FALC&apos;OHM</p>
          <Link className="footerLink" to="/a-propos" onClick={scrollToTop}>
            {t("footer.about")}
          </Link>
          <Link
            className="footerLink"
            to="/mentions-legales"
            onClick={scrollToTop}
          >
            {t("footer.legalNotice")}
          </Link>
          <Link className="footerLink" to="/terms" onClick={scrollToTop}>
            {t("footer.terms")}
          </Link>
        </nav>
      </div>
      <div className="footerIcons">
        <Facebook
          className="facebook"
          onClick={() => window.open(SOCIAL_LINKS.facebook)}
        />
        <Instagram
          className="instagram"
          onClick={() => window.open(SOCIAL_LINKS.instagram)}
        />
      </div>
    </footer>
  );
};

export default Footer;
